import { Location } from "@angular/common";
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SubscriptionLike } from "rxjs";
import { AiSourcingHandlerService } from "../_services/ai-sourcing-handler.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AiSourcingConstant, Tab_Constants_Type, Page_Constants_Type } from "../constants/AiSourcingContants"
import { LocalStorageService } from "../_services/local-storage.service";

@Component({
    selector: 'app-ai-sourcing',
    templateUrl: './ai-sourcing.component.html',
    styleUrls: ['./ai-sourcing.component.scss'],
    standalone: false
})

export class AiSourcingComponent implements OnInit, OnDestroy {

    isProjectListActive: Boolean = false;
    isProjectDetailsActive: Boolean = false;

    isJdDescriptionActive: Boolean = false;
    isSearchCriteriaActive: Boolean = false;
    isEvaluationCriteriaActive: Boolean = false;


    isAISourcingInsightsActive: Boolean = false;
    isAISourcingProfilesActive: Boolean = false;
    isLandingPageActive: Boolean = false;

    isChangeProjectCreationTab: boolean = false;

    subscriptionsLike: SubscriptionLike[] = [];
    showAiSummary: boolean = false;

    storedProjectData: any;
    evaluationCriteriaBackTab: string | null = null;

    readonly Tab_Constants: Tab_Constants_Type = AiSourcingConstant.Tab_Constants
    readonly Page_Constants: Page_Constants_Type = AiSourcingConstant.Page_Constants

    @ViewChild('handleBackEventModel') handleBackEventModel: TemplateRef<any>;
    @ViewChild('handleBackEventForCriteriaModel') handleBackEventForCriteriaModel: TemplateRef<any>;

    constructor(
        private locationService: Location,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private aiSourcingHandlerService: AiSourcingHandlerService,
        private modelService: NgbModal,
        private localstorageservice: LocalStorageService
    ) {

        this.storedProjectData = JSON.parse(this.localstorageservice.getItem('parshedJD'));

        const tab = window.location.pathname;
        if (tab == '/ai-sourcing') {
            this.showPageAsPerRoutes(this.Page_Constants.LANDING_PAGE);
        } else if (tab === '/ai-sourcing/project-list') {
            this.showPageAsPerRoutes(this.Page_Constants.PROJECT_LIST_PAGE);
        } else if (tab.includes('/ai-sourcing/project-details')) {
            this.showPageAsPerRoutes(this.Page_Constants.PROJECT_DETAILS_PAGE);
        } else if (tab === '/ai-sourcing/jd-description') {
            this.showPageAsPerRoutes(this.Page_Constants.JOB_DESCRIPTION_PAGE);
        } else if (tab.includes('/ai-sourcing/ai-sourcing-insights')) {
            this.isAISourcingInsightsActive = true;
            this.isAISourcingProfilesActive = false;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isEvaluationCriteriaActive = false;
        } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/review') || tab.includes('/ai-sourcing/ai-sourcing-profiles/archive') || tab.includes('/ai-sourcing/ai-sourcing-profiles/shortlist') || tab.includes('/ai-sourcing/ai-sourcing-profiles/activity')) {
            this.isAISourcingProfilesActive = true;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isEvaluationCriteriaActive = false;
        } else if (tab.includes('/ai-sourcing/evaluation-criteria')) {
            this.showPageAsPerRoutes(this.Page_Constants.EVALUATION_CRITERIA_PAGE);
        }

        const locationSub = this.locationService.subscribe((p: any) => {
            const tab = p.url;
            if (tab == '/ai-sourcing') {
                this.showPageAsPerRoutes(this.Page_Constants.LANDING_PAGE);
            } else if (tab === '/ai-sourcing/project-list') {
                this.showPageAsPerRoutes(this.Page_Constants.PROJECT_LIST_PAGE);
            } else if (tab.includes('/ai-sourcing/project-details')) {
                this.showPageAsPerRoutes(this.Page_Constants.PROJECT_DETAILS_PAGE);
            } else if (tab === '/ai-sourcing/jd-description') {
                this.showPageAsPerRoutes(this.Page_Constants.JOB_DESCRIPTION_PAGE);
            } else if (tab.includes('/ai-sourcing/ai-sourcing-insights')) {
                this.isAISourcingInsightsActive = true;
                this.isAISourcingProfilesActive = false;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectListActive = false;
                this.isProjectDetailsActive = false;
                this.isEvaluationCriteriaActive = false;
            } else if (tab.includes('/ai-sourcing/ai-sourcing-profiles/review') || tab.includes('/ai-sourcing/ai-sourcing-profiles/archive') || tab.includes('/ai-sourcing/ai-sourcing-profiles/shortlist') || tab.includes('/ai-sourcing/ai-sourcing-profiles/activity')) {
                this.isAISourcingProfilesActive = true;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectListActive = false;
                this.isProjectDetailsActive = false;
                this.isAISourcingInsightsActive = false;
                this.isEvaluationCriteriaActive = false;
            } else if (tab.includes('/ai-sourcing/evaluation-criteria')) {
                this.showPageAsPerRoutes(this.Page_Constants.EVALUATION_CRITERIA_PAGE);
            }
        })

        this.subscriptionsLike.push(locationSub);


    }

    ngOnInit(): void {

        this.aiSourcingHandlerService.getDisplayPageEvent.subscribe((res: String) => {
            // if(res && res !== 'ai-sourcing' && this.isChangeProjectCreationTab) return;
            if (res && res == 'jd-page') {
                this.showPageAsPerRoutes(this.Page_Constants.JOB_DESCRIPTION_PAGE);
            } else if (res && res == 'ai-sourcing') {
                this.showPageAsPerRoutes(this.Page_Constants.LANDING_PAGE);
            } else if (res && res == 'evaluation-page') {
                this.showPageAsPerRoutes(this.Page_Constants.EVALUATION_CRITERIA_PAGE);
            } else if (res && res == 'search-criteria') {
                this.showPageAsPerRoutes(this.Page_Constants.SEARCH_CRITERIA_PAGE);
            } else if (res && res == 'insights') {
                this.isAISourcingInsightsActive = true;
                this.isAISourcingProfilesActive = false;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectListActive = false;
                this.isProjectDetailsActive = false;
                this.isEvaluationCriteriaActive = false;
            } else if (res && res == 'review') {
                this.isAISourcingProfilesActive = true;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectListActive = false;
                this.isProjectDetailsActive = false;
                this.isAISourcingInsightsActive = false;
                this.isEvaluationCriteriaActive = false;
            } else if (res && res == 'shortlist') {
                this.isAISourcingProfilesActive = true;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectListActive = false;
                this.isProjectDetailsActive = false;
                this.isAISourcingInsightsActive = false;
                this.isEvaluationCriteriaActive = false;
            }else if (res && res == 'project-details') {
                this.showPageAsPerRoutes(this.Page_Constants.PROJECT_DETAILS_PAGE);
            } else if (res && res == 'project-insights-summary') {
                this.isProjectListActive = false;
                this.isJdDescriptionActive = false;
                this.isLandingPageActive = false;
                this.isProjectDetailsActive = false;
                this.isAISourcingInsightsActive = true;
                this.isAISourcingProfilesActive = false;
                this.isEvaluationCriteriaActive = false;
                this.showAiSummary = true;
            }
        })

    }

    ngOnDestroy(): void {

    };

    /**
     * Methos to use open handle back event model
     */
    openHandleBackEventModel() {
        this.modelService.open(this.handleBackEventModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    };

    /**
     * Methos to use open handle back event model from evaluation criteria page
     */
    handleBackEventForEvaluationCriteria() {
        this.modelService.open(this.handleBackEventForCriteriaModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

    };

    /**
     * Method to handle back event from evaluation criteria tab
     * @param tab
     */
    confirmBackFromEvaluationPage(tab: string | null) {
        const pd = JSON.parse(this.localstorageservice.getItem('parshedJD'));
        const newData = {
            projectDescription: pd?.projectDescription,
            projectName: pd?.projectName,
            parshedJD: pd?.parshedJD,
            filterApplied: pd?.filterApplied,
            cloneprojectnumber: pd?.cloneprojectnumber,
            redirectSource: pd?.redirectSource,
        };
        this.localstorageservice.setItem('parshedJD', JSON.stringify(newData));

        if (tab === this.Tab_Constants.JOB_DESCRIPTION_TAB) {
            this.changeProjectCreationTab(tab)
        } else if (tab === this.Tab_Constants.SEARCH_CRITERIA_TAB) {
            this.changeProjectCreationTab(tab)
        } else {
            this.handleBackEvent();
        };
        this.dismiss();
    };

    /**
     * Methos to use go to project list
     * If user wants to back
     */
    handleBackEvent() {
        const pd = JSON.parse(this.localstorageservice.getItem('parshedJD'));
        if (pd && pd.isEvaluationPage) {
            this.handleBackEventForEvaluationCriteria();
            return;
        }

        if (this.isJdDescriptionActive) {
            this.localstorageservice.clearItem('parshedJD');
            this.dismiss();
            this.showPageAsPerRoutes(this.Page_Constants.PROJECT_LIST_PAGE);
            this.router.navigate(['/ai-sourcing/project-list']);
        } else if (this.isSearchCriteriaActive) {
            this.changeProjectCreationTab(this.Page_Constants.JOB_DESCRIPTION_PAGE)
            const newData = {
                projectDescription: pd?.projectDescription,
                projectName: pd?.projectName,
                cloneprojectnumber: pd?.cloneprojectnumber,
                redirectSource: pd?.redirectSource,
            };
            // this.localstorageservice.setItem('parshedJD', JSON.stringify(newData));
        } else if (this.isEvaluationCriteriaActive) {
            this.changeProjectCreationTab(this.Page_Constants.SEARCH_CRITERIA_PAGE)
            const newData = {
                projectDescription: pd?.projectDescription,
                projectName: pd?.projectName,
                parshedJD: pd?.parshedJD,
                filterApplied: pd?.filterApplied,
                cloneprojectnumber: pd?.cloneprojectnumber,
                redirectSource: pd?.redirectSource
            };
            // this.localstorageservice.setItem('parshedJD', JSON.stringify(newData));
        } else {
            this.localstorageservice.clearItem('parshedJD');
            this.showPageAsPerRoutes(this.Page_Constants.PROJECT_LIST_PAGE);
            this.router.navigate(['/ai-sourcing/project-list']);
        }
    };

    /**
     * Methos to use handle dismiss active model
     */
    dismiss() {
        this.modelService.dismissAll();
    }

    /**
     * Method to handle project creation tab changes
     * @param tab
     */
    changeProjectCreationTab(tab: string) {
        this.storedProjectData = JSON.parse(this.localstorageservice.getItem('parshedJD'));
        if (!this.storedProjectData) return;
        if (this.storedProjectData && this.storedProjectData.isEvaluationPage) {
            this.handleBackEventForEvaluationCriteria();
            this.evaluationCriteriaBackTab = tab;
            return;
        } else {
            this.evaluationCriteriaBackTab = null;
        }

        if (tab === this.Tab_Constants.JOB_DESCRIPTION_TAB) {
            if (!this.storedProjectData?.projectName && !this.storedProjectData?.projectDescription) return;
            this.showPageAsPerRoutes(this.Page_Constants.JOB_DESCRIPTION_PAGE);
            this.router.navigate([`/ai-sourcing/jd-description`]);
            setTimeout(() => {
                this.aiSourcingHandlerService.setShowFilterComponent(false);
            })
        } else if (tab === this.Tab_Constants.SEARCH_CRITERIA_TAB) {
            if (!this.storedProjectData?.parshedJD) return;
            if (!this.isJdDescriptionActive) {
                this.router.navigate([`/ai-sourcing/jd-description`]);
            }
            this.showPageAsPerRoutes(this.Page_Constants.SEARCH_CRITERIA_PAGE);
            setTimeout(() => {
                this.aiSourcingHandlerService.setShowFilterComponent(true);
            })
        } else if (tab === this.Tab_Constants.EVALUATION_CRITERIA_TAB) {
            if (!this.storedProjectData?.isEvaluationPage) return;
            this.showPageAsPerRoutes(this.Page_Constants.EVALUATION_CRITERIA_PAGE);
            this.router.navigate([`/ai-sourcing/evaluation-criteria`]);
        } else {
            this.showPageAsPerRoutes(null);
            this.router.navigate([`/ai-sourcing`]);
        }
        this.isChangeProjectCreationTab = true;

    };

    /**
     * Method to handle show current pages sidebar data
     * @param page
     */
    showPageAsPerRoutes(page: string) {
        if (page === this.Page_Constants.LANDING_PAGE) {
            this.isLandingPageActive = true;
            this.isProjectListActive = false;
            this.isJdDescriptionActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isSearchCriteriaActive = false;
            this.router.navigate([`/ai-sourcing`]);
        } else if (page === this.Page_Constants.PROJECT_LIST_PAGE) {
            this.isProjectListActive = true;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isChangeProjectCreationTab = false;
            this.isSearchCriteriaActive = false;
        } else if (page === this.Page_Constants.PROJECT_DETAILS_PAGE) {
            this.isProjectDetailsActive = true;
            this.isProjectListActive = false;
            this.isLandingPageActive = false;
            this.isJdDescriptionActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isSearchCriteriaActive = false;
        } else if (page === this.Page_Constants.JOB_DESCRIPTION_PAGE) {
            this.isJdDescriptionActive = true;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isSearchCriteriaActive = false;
        } else if (page === this.Page_Constants.SEARCH_CRITERIA_PAGE) {
            this.isSearchCriteriaActive = true;
            this.isProjectListActive = false;
            this.isLandingPageActive = false;
            this.isJdDescriptionActive = false;
            this.isProjectDetailsActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
        } else if (page === this.Page_Constants.EVALUATION_CRITERIA_PAGE) {
            this.isEvaluationCriteriaActive = true;
            this.isSearchCriteriaActive = false;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
        } else if (page === this.Page_Constants.INSIGHTS_PAGE) {
            this.isAISourcingInsightsActive = true;
            this.isAISourcingProfilesActive = false;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isSearchCriteriaActive = false;
        } else if ((page === 'profiles-review-tab') || (page === 'profiles-archive-tab') || (page === 'profiles-shortlist-tab') || (page === 'profiles-activity-tab')) {
            this.isAISourcingProfilesActive = true;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isEvaluationCriteriaActive = false;
            this.isSearchCriteriaActive = false;
        } else {
            this.isEvaluationCriteriaActive = false;
            this.isJdDescriptionActive = false;
            this.isLandingPageActive = false;
            this.isProjectListActive = false;
            this.isProjectDetailsActive = false;
            this.isAISourcingInsightsActive = false;
            this.isAISourcingProfilesActive = false;
            this.isSearchCriteriaActive = false;
        }
    };

}
